import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnalyticsComponent } from './analytics/analytics.component';
import { AuthGuard } from './auth.guard';
import { AuthenticationComponent } from './authentication/authentication.component';
import { ContentComponent } from './content/content.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { PeoplesComponent } from './peoples/peoples.component';
import { ProfileComponent } from './profile/profile.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SavePeopleComponent } from './save-people/save-people.component';
import { UpdateAdminComponent } from './update-admin/update-admin.component';
import { DemographicDataComponent } from './demographic-data/demographic-data.component';
import { BannersComponent } from './banners/banners.component';
import { ResourcesComponent } from './resources/resources.component';
import { LanguagesComponent } from './languages/languages.component';
import { LanguageDetailComponent } from './language-detail/language-detail.component';

const routes: Routes = [
  {
    path:'',
    component: PeoplesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent
  }, 
  {
    path: "reset-password",
    component: ResetPasswordComponent,
  },
  {
    path: "authenticate",
    component: AuthenticationComponent,
  },
  {
    path: 'people',
    component: PeoplesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "add-people",
    component: SavePeopleComponent,
    canActivate: [AuthGuard]
  },{
    path: "update-people",
    component: SavePeopleComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "content",
    component: ContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "analytics",
    component: AnalyticsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "profile",
    component: ProfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "update-admin",
    component:  UpdateAdminComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "demographic-data",
    component: DemographicDataComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "banners",
    component: BannersComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "resources",
    component: ResourcesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "language-content",
    component: LanguagesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "language-detail/:id",
    component: LanguageDetailComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
